import { render, staticRenderFns } from "./giftPackageViewLog.vue?vue&type=template&id=8d057284&scoped=true&"
import script from "./giftPackageViewLog.vue?vue&type=script&lang=js&"
export * from "./giftPackageViewLog.vue?vue&type=script&lang=js&"
import style0 from "./giftPackageViewLog.vue?vue&type=style&index=0&id=8d057284&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d057284",
  null
  
)

export default component.exports